module.exports = __webpack_public_path__ + "67488a7d59c61923b191b5ff594d4d9a.fbx";